import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ICommentItem } from 'src/app/components/main-content/design-lookup/lists/comment-list/comment-list.component';
import { ElementHistoryLog } from 'src/app/models/domain';
import { DesignService, ElementHistoryLogService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-element-history-log',
  templateUrl: './element-history-log.component.html',
  standalone: false,
})
export class ElementHistoryLogComponent implements OnInit, OnDestroy {
  public pageIndex$ = this.elementHistoryLogService.pageIndex$;
  public pageSize$ = this.elementHistoryLogService.pageSize$;
  public webUrl$ = this.elementHistoryLogService.webUrl$;
  public worksheetName$ = this.elementHistoryLogService.worksheetName$;
  public elementHistoryLogSize$ = this.elementHistoryLogService.logSize$;
  public siteUrl = environment.sharePointEHDSiteUrl;
  public designLoading$ = this.designService.loading$;
  public error$ = this.elementHistoryLogService.error$;
  public elementHistoryLogLoading$ = this.elementHistoryLogService.loading$;

  public elementHistoryLogs$ = this.elementHistoryLogService.paginatedLog$.pipe(
    map((elementHistoryLogs) => this.convertToCommentItems(elementHistoryLogs))
  );

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly elementHistoryLogService: ElementHistoryLogService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((designId) => this.elementHistoryLogService.loadById(designId)))
        .subscribe()
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public changePage(pageIndex: number) {
    this.elementHistoryLogService.updatePageIndex(pageIndex);
  }

  public changePageSize(pageSize: number) {
    this.elementHistoryLogService.updatePageSize(pageSize);
  }

  private convertToCommentItems(logs: ElementHistoryLog[]): ICommentItem[] {
    return logs.map((log) => ({
      author: log.responsible,
      content: log.comments,
      dateTime: log.date,
    }));
  }
}
